import { ComponentRule, ComponentRules, CustomRule, MaxLengthRule, MaxValueRule, MinLengthRule, MinValueRule } from './ComponentRule';
import ComponentField from './ComponentField';

class ComponentRuleExecutor {
  public static async execute(field: ComponentField, value: any): Promise<ComponentRule[]> {
    const errors: ComponentRule[] = [];
    for (const rule of field.getRules()) {
      try {
        if (!(await this.executeRule(rule, value))) {
          errors.push(rule);
        }
      } catch (e) {
        console.error(e);
        errors.push(rule);
      }
    }
    return errors;
  }

  private static async executeRule(rule: ComponentRule, value: any): Promise<boolean> {
    switch (rule.type) {
      case ComponentRules.REQUIRED:
        return this.required(value);
      case ComponentRules.MIN_LENGTH:
        return this.minLength(value, (rule as MinLengthRule).minLength);
      case ComponentRules.MAX_LENGTH:
        return this.maxLength(value, (rule as MaxLengthRule).maxLength);
      case ComponentRules.MIN_VALUE:
        return this.minValue(value, (rule as MinValueRule).minValue);
      case ComponentRules.MAX_VALUE:
        return this.maxValue(value, (rule as MaxValueRule).maxValue);
      case ComponentRules.CUSTOM:
        return (rule as CustomRule).rule(value);
      default:
        return false;
    }
  }

  private static required(value: any): boolean {
    return value !== null && value !== undefined && value !== '';
  }

  private static minLength(value: string, minLength: number): boolean {
    return value.length >= minLength;
  }

  private static maxLength(value: string, maxLength: number): boolean {
    return value.length <= maxLength;
  }

  private static minValue(value: number, minValue: number): boolean {
    return value >= minValue;
  }

  private static maxValue(value: number, maxValue: number): boolean {
    return value <= maxValue;
  }
}

export default ComponentRuleExecutor;
